import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import {
  CurrencyExchangeOutlined,
  CancelOutlined,
  PaymentsOutlined,
  GppGoodOutlined,
  DoNotDisturbAltOutlined,
  AccessTimeOutlined,
  ContactSupportOutlined,
} from "@mui/icons-material";
import Footer from "./Footer";

const RefundCanc=()=>{
  const sections = [
    {
      icon: <CurrencyExchangeOutlined fontSize="large" color="primary" />,
      title: "About Our Refund Policy",
      content:
        "PriceWorth provides digital services including buying group participation, price negotiation, and premium membership services. Since many of our services are digital and begin immediately after purchase, refunds are subject to specific eligibility conditions.",
    },
    {
      icon: <CancelOutlined fontSize="large" color="error" />,
      title: "Cancellation by User",
      content:
        "Users may cancel their participation before the negotiation process has been finalized, where cancellation is applicable. Once negotiations begin or services are actively delivered, cancellation requests may no longer be accepted because resources have already been committed.",
    },
    {
      icon: <PaymentsOutlined fontSize="large" color="success" />,
      title: "Refund Eligibility",
      content:
        "Refund requests may be approved under exceptional circumstances, including duplicate payments, payment failures where the amount was debited but the service was not activated, technical failures that prevent service delivery, or other special situations reviewed and approved by the PriceWorth support team. Refund requests must be submitted within 7 days of the original payment date.",
      list: [
        "Duplicate payment",
        "Payment debited but service failed",
        "Technical issue preventing service",
        "Exceptional cases approved by PriceWorth",
      ],
    },
    {
      icon: <DoNotDisturbAltOutlined fontSize="large" color="warning" />,
      title: "Non-Refundable Cases",
      content:
        "Refunds are generally not available once digital services have commenced or value has already been delivered to the user.",
      list: [
        "Negotiation process has already started",
        "Buying group benefits have already been delivered",
        "Digital access has been activated",
        "User voluntarily leaves after services begin",
      ],
    },
    {
      icon: <AccessTimeOutlined fontSize="large" color="info" />,
      title: "Refund Processing Time",
      content:
        "Once a refund request is approved, the refund will be processed within 7–10 business days. The refunded amount will be credited back to the original payment method used during the transaction. Processing time may vary depending on your bank or payment provider.",
    },
    {
      icon: <GppGoodOutlined fontSize="large" color="success" />,
      title: "Fair Usage Policy",
      content:
        "PriceWorth reserves the right to reject refund requests that appear fraudulent, abusive, or inconsistent with this policy. Every refund request is reviewed carefully to ensure fairness for both customers and service providers.",
    },
    {
      icon: <ContactSupportOutlined fontSize="large" color="primary" />,
      title: "Need Help?",
      content:
        "If you have any questions regarding refunds or cancellations, our support team is available to assist you.",
      list: [
        "Email: refunds@priceworth.com",
        "Business Hours: Monday - Friday",
        "Response Time: Within 24-48 Hours",
      ],
    },
  ];

  return (
    <>
     <div
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: "50px 0",
      }}
    >
      <Container>
        {/* Hero Section */}
        <div
          style={{
            background:
             "linear-gradient(135deg,#1e3a8a,#2563eb,#3b82f6)",
            borderRadius: 25,
            padding: "60px 30px",
            color: "#fff",
            textAlign: "center",
            marginBottom: 40,
            boxShadow: "0 20px 45px rgba(37,99,235,.25)",
          }}
        >
          <CurrencyExchangeOutlined style={{ fontSize: 70 }} />

          <h1
            style={{
              fontWeight: 700,
              marginTop: 20,
            }}
          >
            Refund & Cancellation Policy
          </h1>

          <p
            style={{
              maxWidth: 850,
              margin: "20px auto",
              color: "#dbeafe",
              lineHeight: 1.8,
              fontSize: 16,
            }}
          >
            We strive to provide transparent and fair refund practices.
            Please read this policy carefully to understand when refunds
            and cancellations are available for PriceWorth services.
          </p>
        </div>

        <Row>
          {sections.map((section, index) => (
            <Col lg="6" className="mb-4" key={index}>
              <Card
                style={{
                  border: "none",
                  borderRadius: 20,
                  boxShadow: "0 10px 30px rgba(0,0,0,.08)",
                  height: "100%",
                }}
              >
                <CardBody style={{ padding: 30 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 20,
                    }}
                  >
                    <div
                      style={{
                        width: 65,
                        height: 65,
                        borderRadius: "50%",
                        background: "#eff6ff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 18,
                      }}
                    >
                      {section.icon}
                    </div>

                    <h4
                      style={{
                        margin: 0,
                        fontWeight: 700,
                        color: "#1e293b",
                      }}
                    >
                      {section.title}
                    </h4>
                  </div>

                  <p
                    style={{
                      color: "#475569",
                      lineHeight: 1.9,
                      textAlign: "justify",
                    }}
                  >
                    {section.content}
                  </p>

                  {section.list && (
                    <ul
                      style={{
                        color: "#334155",
                        lineHeight: 2,
                        paddingLeft: 20,
                      }}
                    >
                      {section.list.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Footer Notice */}
        <Card
          style={{
            marginTop: 20,
            border: "none",
            borderRadius: 20,
            background: "#e0f2fe",
            boxShadow: "0 8px 20px rgba(0,0,0,.08)",
          }}
        >
          <CardBody className="text-center p-4">
            <h4
              style={{
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              Important Notice
            </h4>

            <p
              style={{
                color: "#334155",
                marginBottom: 0,
                lineHeight: 1.8,
              }}
            >
              By purchasing or participating in PriceWorth services, you
              acknowledge that you have read and agreed to this Refund &
              Cancellation Policy. We recommend reviewing this page before
              making any purchase.
            </p>
          </CardBody>
        </Card>
      </Container>
    </div>

    <Footer/>
    
    </>
   
  );
}

export default RefundCanc;